import React, { Component } from "react";
import { tableConfigReasonDrop } from "../config";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import { saveAs } from "file-saver";
import FlexView from "react-flexview";

class ReportReasonDrop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      config: [...tableConfigReasonDrop],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.doSearch !== this.props?.doSearch && this.props?.doSearch) {
      this.fetchData();
    }
  }

  transformProspekDataList = (list = []) => {
    return list.map((data) => {
      const result = {
        cabang: data.cabang,
        totalDrop: data.totalDrop,
      };

      Object.entries(data).forEach(([key, value]) => {
        if (typeof value === "object" && value?.percentage !== undefined) {
          result[key] = value?.totalProspekReason || 0;
          result[`${key} Percentage`] = value.percentage;
        }
      });

      return result;
    });
  };

  titleToCamel = (str = "") =>
  str
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+(.)/g, (_, c) => c.toUpperCase());

  fetchData = async () => {
    const {
      setError,
      isAllSelected,
      kodeCabang,
      cabangOptions,
      month,
      year,
      onTriggerLoading,
      onSuccessSearch,
    } = this.props;

    const cabang = isAllSelected ? cabangOptions : kodeCabang;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikDrop,
      setError: setError,
      menuName: "Dashboard CRM Kabeng Kacab - Prospek Monitoring Alasan DROP",
      args: {
        listCabang: cabang?.map((item) => item.value),
        month: month?.value,
        year: year?.value,
      },
    });

    onTriggerLoading();
    onSuccessSearch();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      if (res.data.data.length === 0) {
        return;
      }

      const { cabang, totalDrop, ...skeleton } = res.data.data[0] || {};
      this.setState({
        dataTable: this.transformProspekDataList(res.data.data),
        config: [
          tableConfigReasonDrop[0],
          ...Object.entries(skeleton).flatMap(([key, value]) => [
            {
              name: key,
              label: key,
              options: {
                sort: false,
                setCellHeaderProps: () => ({
                  style: {
                    width: "100px",
                    minWidth: "100px",
                    textAlign: "center",
                  },
                }),
                setCellProps: () => ({
                  style: { textAlign: "center" },
                }),
              },
            },
            {
              name: `${key} Percentage`,
              label: `${key} (%)`,
              options: {
                sort: false,
                setCellHeaderProps: () => ({
                  style: {
                    width: "150px",
                    minWidth: "150px",
                    textAlign: "center",
                  },
                }),
                setCellProps: () => ({
                  style: { textAlign: "center" },
                }),
              },
            },
          ]),
          tableConfigReasonDrop[1],
        ],
      });
    }
  };

  mapRowByConfigLabel = (dataList = [], columns = []) => {
    return dataList.map((row) => {
      const result = {};

      columns.forEach((col) => {
        result[col.label] = row[col.name];
      });

      return result;
    });
  };

  handlePrint = async () => {
    const { dataTable, config } = this.state;
    const { onTriggerLoading, setError, month, year } = this.props;
    onTriggerLoading();

    const filename = `${year?.value}_${month.label}_Laporan_Statistik_Alasan_DROP`;
    const reqBody = {
      filename,
      sheets: [
        {
          name: "Laporan Statistik Alasan DROP",
          headers: config?.map((col) => col.label),
          data: this.mapRowByConfigLabel(dataTable, config),
        },
      ],
    };

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
      menuName: "Dashboard CRM Kabeng Kacab - Prospek Monitoring Alasan DROP",
      setError: setError,
      args: reqBody,
    });

    if (res?.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, `${reqBody.filename}.xlsx`);
    }
    onTriggerLoading();
  };

  render() {
    const { dataTable, config } = this.state;
    return (
      <React.Fragment>
        <SimpleDataTable
          data={dataTable}
          columns={config}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
            <SimpleButton
              id="btn_print"
              text="Cetak"
              onClick={() => this.handlePrint()}
            />
        </FlexView>
      </React.Fragment>
    );
  }
}

export default ReportReasonDrop;
